import { render, staticRenderFns } from "./Ambassades.vue?vue&type=template&id=531d44b6&scoped=true&"
import script from "./Ambassades.vue?vue&type=script&lang=js&"
export * from "./Ambassades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d44b6",
  null
  
)

export default component.exports